exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\n.refurbished-body {\n    overflow: hidden;\n}\n}\n.check-price-cant {\n  text-align: inherit;\n  margin-bottom: 15px;\n}\n.check-price-cant p {\n  font-size: 14px;\n}", ""]);

// exports
